// Bambody v3 collection grid — per-card image cycling + ATC.
// Reads product data from <script data-bam-v3-colgrid-data> emitted by
// sections/bambody-v3-collection-grid.liquid, and attaches handlers to
// cards by [data-card-idx].

(function () {
  const state = []   // parallel array to cards: { images, imgIdx, variantId, available }

  function loadCards() {
    const el = document.querySelector('script[data-bam-v3-colgrid-data]')
    if (!el) return null
    try { return JSON.parse(el.textContent).cards || [] } catch { return null }
  }

  function cardEl(idx) {
    return document.querySelector(`.bam-v3-colgrid__card[data-card-idx="${idx}"]`)
  }

  function renderImage(idx) {
    const card = cardEl(idx); if (!card) return
    const st = state[idx]; if (!st) return
    const img = card.querySelector('[data-card-img]')
    if (img && st.images[st.imgIdx]) img.src = st.images[st.imgIdx]
    // Show arrows only if more than one image
    const prev = card.querySelector('.bam-v3-colgrid__arrow--prev')
    const next = card.querySelector('.bam-v3-colgrid__arrow--next')
    const multi = st.images.length > 1
    if (prev) prev.hidden = !multi
    if (next) next.hidden = !multi
  }

  window.bamV3ColgridStep = function (idx, delta) {
    const st = state[idx]; if (!st || st.images.length <= 1) return
    st.imgIdx = (st.imgIdx + delta + st.images.length) % st.images.length
    renderImage(idx)
  }

  // ATC — same event contract as PDP/shop, so the cart drawer opens automatically.
  const SPINNER = '<span class="bam-v3-spin" aria-hidden="true"></span>'
  const ICON_CART = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="8" cy="21" r="1"/><circle cx="19" cy="21" r="1"/><path d="M2.05 2.05h2l2.66 12.42a2 2 0 002 1.58h9.78a2 2 0 001.95-1.57l1.65-7.43H5.12"/></svg>'
  const ICON_CHECK = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>'

  function setAtcState(btn, state) {
    if (!btn) return
    btn.disabled = state === 'loading'
    btn.classList.remove('added')
    if (state === 'loading') btn.innerHTML = `${SPINNER}<span>Adding…</span>`
    else if (state === 'success') { btn.classList.add('added'); btn.innerHTML = `${ICON_CHECK}<span>Added</span>` }
    else btn.innerHTML = `${ICON_CART}<span>Add to cart</span>`
  }

  window.bamV3ColgridAtc = async function (idx) {
    const st = state[idx]; if (!st || !st.variantId || !st.available) return
    const card = cardEl(idx); if (!card) return
    const btn = card.querySelector('.bam-v3-colgrid__atc')
    setAtcState(btn, 'loading')
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: st.variantId, quantity: 1 }] }),
      })
      if (!res.ok) throw new Error('add-to-cart failed')
      const item = await res.json().catch(() => null)
      setAtcState(btn, 'success')
      document.dispatchEvent(new CustomEvent('bam:cart:added', { detail: { variantId: st.variantId, item } }))
      setTimeout(() => setAtcState(btn, 'idle'), 1500)
    } catch (e) { console.error(e); setAtcState(btn, 'idle') }
  }

  document.addEventListener('DOMContentLoaded', () => {
    const cards = loadCards()
    if (!cards) return
    cards.forEach((c, i) => {
      state[i] = { images: c.images || [], imgIdx: 0, variantId: c.variantId, available: c.available }
      renderImage(i)
    })
  })
})();
